import { render, staticRenderFns } from "./TransferenciaLocComponent.vue?vue&type=template&id=62d277a6&"
import script from "./TransferenciaLocComponent.vue?vue&type=script&lang=js&"
export * from "./TransferenciaLocComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports